/**
 * SKN Module
 */
//Core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

//lib modules
import { UIModule } from 'libraries/ui/ui.module';
import { GenericModule } from 'libraries/module/generic.module';
import { ApiModule } from 'libraries/module/api.module';
import { ListModule } from 'libraries/module/list.module';
import { FormModule } from 'libraries/module/form.module';
import { PersonModule } from 'libraries/module/person.module';
import { AirModule } from 'libraries/module/air.module';
import { NotificationModule } from "libraries/component/notification/notification.module";


//Routing
import { SynchronymeRoutingModule } from "./synchronyme-routing";

//App Services
import { TnrService } from "./service/tnr/tnr.service";
import { PnrService } from "./service/pnr/pnr.service";
import { SynchronymeService } from "./service/synchronyme/synchronyme.service";

import { JourneyModule } from "libraries/component/journey/journey.module";

//Components
import { SynchronymeComponent } from './synchronyme.component';
import { TnrListComponent } from './component/tnrlist/tnrlist.component';
import { PnrListComponent } from './component/pnrlist/pnrlist.component';
import { GroupResourceModule } from "libraries/service/resources/group/groupResource.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { LabelModule } from "libraries/service/label/label.module";
import { CardModule } from 'libraries/ui_card/card.module';
import { LocationPipeModule } from 'libraries/pipes/location/location.module';

// tslint:disable no-import-side-effect
import '../styles/angular-material/theming.scss?global';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        AirModule,
        ApiModule,
        CommonModule,
        FormModule,
        FormsModule,
        GenericModule,
        GroupResourceModule,
        JourneyModule,
        LoaderModule,
        ListModule,
        LocationPipeModule,
        NotificationModule,
        PersonModule,
        SynchronymeRoutingModule,
        UIModule,
        CardModule,
        LabelModule,
        FontAwesomeModule,
    ],
    declarations: [
        PnrListComponent,
        SynchronymeComponent,
        TnrListComponent,
    ],

    bootstrap: [
        SynchronymeComponent,
    ],
    providers: [
        PnrService,
        SynchronymeService,
        TnrService,
    ]
})
export class SynchronymeModule {
}
